import { html } from 'lit';

import { chatConfig } from '@effectivastudio/lit-components/components/chat/lib/config.js';
// components/chat_list_item/element.js

import ChatListItem from '@effectivastudio/lit-components/components/chat_list_item/element.js';

ChatListItem.renderMenu = chatId => {
  return html`<bu-chat-menu role="menu" .chatId=${chatId}></bu-chat-menu>`;
};

chatConfig.fileLayout = 'lg';
chatConfig.icons.new_message_indicator = 'chevron-down';
chatConfig.icons.retry = 'redo';
chatConfig.icons.dismiss = 'close';
chatConfig.icons.states.final_seen = 'check';
chatConfig.icons.form.exit_edit_mode = 'close';
chatConfig.menu.infoOn = true;
